// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-bar {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.pagination-container {
  list-style-type: none;
}

.pagination-container .pagination-item {
  padding: 0 12px;
  height: 32px;
  text-align: center;
  /* margin: auto 4px; */
  color: rgba(0, 0, 0, .87);
  display: flex;
  box-sizing: border-box;
  align-items: center;
  letter-spacing: .01071em;
  border-radius: 16px;
  line-height: 1.43;
  font-size: 13px;
  min-width: 32px;
  cursor: pointer;
}

.pagination-container .pagination-item .arrow.left {
  transform: rotate(-135deg) translate(-50%);
}

.pagination-container .pagination-item .arrow::before {
  position: relative;
  content: "";
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  border-right: 0.12em solid rgba(0, 0, 0, .87);
  border-top: 0.12em solid rgba(0, 0, 0, .87);
}

.pagination-container .pagination-item .arrow.right {
  transform: rotate(45deg);
}

.pagination-container .pagination-item.disabled {
  pointer-events: none;
}

.pagination-container .pagination-item.selected {
  background-color: rgba(0, 0, 0, .08);
  color: var(--secondary-color);
}

.pagination-container .pagination-item:hover {
  background-color: rgba(0, 0, 0, .04);
  cursor: pointer;
}

.active-sort {
  opacity: 0.6;
}

@media (max-width: 768px) {
  .pagination-container .pagination-item {
    padding: 0 8px;
    height: 25px;
    min-width: 25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assests/css/pagination.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".pagination-bar {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 10px;\r\n}\r\n\r\n.pagination-container {\r\n  list-style-type: none;\r\n}\r\n\r\n.pagination-container .pagination-item {\r\n  padding: 0 12px;\r\n  height: 32px;\r\n  text-align: center;\r\n  /* margin: auto 4px; */\r\n  color: rgba(0, 0, 0, .87);\r\n  display: flex;\r\n  box-sizing: border-box;\r\n  align-items: center;\r\n  letter-spacing: .01071em;\r\n  border-radius: 16px;\r\n  line-height: 1.43;\r\n  font-size: 13px;\r\n  min-width: 32px;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination-container .pagination-item .arrow.left {\r\n  transform: rotate(-135deg) translate(-50%);\r\n}\r\n\r\n.pagination-container .pagination-item .arrow::before {\r\n  position: relative;\r\n  content: \"\";\r\n  display: inline-block;\r\n  width: 0.4em;\r\n  height: 0.4em;\r\n  border-right: 0.12em solid rgba(0, 0, 0, .87);\r\n  border-top: 0.12em solid rgba(0, 0, 0, .87);\r\n}\r\n\r\n.pagination-container .pagination-item .arrow.right {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.pagination-container .pagination-item.disabled {\r\n  pointer-events: none;\r\n}\r\n\r\n.pagination-container .pagination-item.selected {\r\n  background-color: rgba(0, 0, 0, .08);\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.pagination-container .pagination-item:hover {\r\n  background-color: rgba(0, 0, 0, .04);\r\n  cursor: pointer;\r\n}\r\n\r\n.active-sort {\r\n  opacity: 0.6;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .pagination-container .pagination-item {\r\n    padding: 0 8px;\r\n    height: 25px;\r\n    min-width: 25px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
